import SideBar from "../../components/UserDashboard/SideBar";
import "../../styles/UserDashboard/Profile.scss";
import { useEffect, useRef, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Tabs, Tab } from "@mui/material";
import {
  getBanks,
  getKyc,
  getUserInfo,
  saveBankDetails,
  updateUserInfo,
  verifyAccount,
} from "../../apis/General/users";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Kyc from "../../components/UserDashboard/Kyc";
import Search from "../../components/UserDashboard/Search";
import { Link, useLocation, useParams } from "react-router-dom";
import { getGrandTruthMapping } from "../../apis/EnergyEfficient/EfficientApi";
import { useQuery } from "@tanstack/react-query";
import {viewComment} from "../../apis/UserDashboard/dashboard"

import axios from "axios";

import {
  updateUserKyc,
  updateUserKycUser,
} from "../../apis/AdminDashboard/users";
import { countries } from "../../data/countries";

// function TabPanel(props) {
//     const { children, value, index, ...other } = props;

//     return (
//       <div
//         role="tabpanel"
//         hidden={value !== index}
//         id={`simple-tabpanel-${index}`}
//         aria-labelledby={`simple-tab-${index}`}
//         {...other}
//       >
//         {value === index && (
//           <Box sx={{ p: 3 }}>
//             <Typography>{children}</Typography>
//           </Box>
//         )}
//       </div>
//     );
//   }

//   TabPanel.propTypes = {
//     children: PropTypes.node,
//     index: PropTypes.number.isRequired,
//     value: PropTypes.number.isRequired,
//   };

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
// for grand truth mapping 

// const initialData = {
//   "Home Appliances": [
//     { label: "Bottle warmer", value: "150W" },
//     { label: "Electric steamer", value: "180W" },
//     { label: "Hair straightener", value: "220W" },
//     { label: "Juicer", value: "135W" },
//     { label: "Smoothie maker", value: "300W" },
//   ],
//   "Facility Appliances": [
//     { label: "Autoclaves", value: "220W" },
//     { label: "Floodlights", value: "150W" },
//     { label: "Projector", value: "180W" },
//     { label: "Speakers", value: "135W" },
//   ],
//   Others: [
//     { label: "Pan", value: "150W" },
//   ],
// };

const Settings = ({token}) => {
  const auth = useSelector((state) => state.auth);


   // Use react-query for withdrawal history
    // const { data, isLoading, error } = useQuery({
    //   queryKey: ["grand truth mapping", auth?.token],
    //   queryFn: () => getGrandTruthMapping(auth?.token),
    //   enabled: !!auth?.token,
    // });
    // if(data)
    // {
    //   console.log(data)
    // }
// const initialData = data?.data
    // if (data){
    //   console.log(data)
    // }
  
    // Extract withdrawal items from API response
  //   const withdrawalItems = data?.data?.data?.items || [];
  // console.log("withdrawalItems", withdrawalItems);
  const { pathname } = useLocation();
  console.log("pathname", pathname);

  const [value, setValue] = useState(0);
  const [user, setUser] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUserName] = useState("");
  const [address, setAddress] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [country, setCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(false);
  const [organizationDescription, setOrganizationDescription] = useState("");
  const [quantifiedBasedYearInventory, setQuantifiedBasedYearInventory] =
    useState("");
  const [publicKey, setPublicKey] = useState("");
  const [pdrDoc, setPdrDoc] = useState("");
  const [facilityCategory, setFacilityCategory] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [uplaodLoading, setUploadLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [banks, setBanks] = useState([]);
  const [accountNum, setAccountNum] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [bankLoading, setBankLoading] = useState(false);
  const [accName, setAccName] = useState("");
  const [justAddedBankDetails, setJustAddedBankDetails] = useState(false);
  const [bankDetailsFilled, setBankDetailsFilled] = useState(false);
  const [kycStatus, setKycStatus] = useState(false);

  const [facilityName, setFacilityName] = useState("");
  const [facilityDescription, setFacilityDescription] = useState("");
  const [location, setLocation] = useState("");
  const [greenProjectLicenseId, setGreenProjectLicenseId] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectEndDate, setProjectEndDate] = useState("");
  const [fuelSource, setFuelSource] = useState("");
  const [renewableEnergySolutions, setRenewableEnergySolutions] = useState("");
  const [baseline, setBaseline] = useState("");
  const [fuelSourceBaseline, setFuelSourceBaseline] = useState("");
  const [additonalInfo, setAdditonalInfo] = useState("");
  const [sustainabilitySolution, setSustainabilitySolution] = useState("");
  const [doubleCounting, setDoubleCounting] = useState("");
  const [comment , setComment ] = useState([])

  const open2 = Boolean(anchorEl2);
  const mediaRef = useRef(null);

  const clickFileUpload = (e, documentTypeSent) => {
    setUploadLoading(true);

    let files = e.target.files;
    let allUploadedFiles = images;

    const fileToUri = (file, cb) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(null, reader.result);
      };
      reader.onerror = function (error) {
        cb(error, null);
      };
    };

    if (files) {
      for (let i = 0; i < files.length; i++) {
        fileToUri(files[0], (err, result) => {
          if (result) {
            console.log("result", result);
            axios
              .post(
                `${process.env.REACT_APP_API_URL}/open/v1/upload`,
                {
                  media_type: "docx",
                  folder: "word_documents",
                  user_id: auth?.userInfo?.id,
                  contents: [result],
                },
                {
                  headers: {
                    Authorization: `Bearer ${auth ? auth.token : ""}`,
                  },
                }
              )
              .then((response) => {
                console.log("response file uploaded", response);
                if (response?.data?.body?.success === true) {
                  if (documentTypeSent === "projectDescriptionReport") {
                    setPdrDoc(response?.data?.body?.data[0]);
                    handleClose2();
                    alert("Project description report uploaded");
                  } else if (
                    documentTypeSent === "quantifiedBaseYearInventory"
                  ) {
                    setQuantifiedBasedYearInventory(
                      response?.data?.body?.data[0]
                    );
                    handleClose();
                    alert("Quantified base year inventory uploaded");
                  } else {
                    toast.error("document type not specified");
                  }
                }
                setUploadLoading(false);
              })
              .catch((err) => {
                setUploadLoading(false);
              });
          }
        });
      }
    }
  };
    const getComment = async()=>{
      
      const getID = await getKyc(auth?.userInfo?.id, auth?.token);
      console.log("getKyc", getID?.data?.message.id);
      const CommentResponse =  await viewComment(getID?.data?.message.id, auth?.token)
      setComment(CommentResponse)
      console.log("CommentResponse",CommentResponse.data.additionalComment
  )
    }
  

  useEffect(() => {
    getComment()
    console.log("pdrDoc", pdrDoc);
  }, [pdrDoc]);
  useEffect(() => {
    console.log("quantifiedBasedYearInventory", quantifiedBasedYearInventory);
  }, [quantifiedBasedYearInventory]);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const fetchUserInfo = async () => {
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log('getUser', response);
    const response2 = await getKyc(auth?.userInfo?.id, auth?.token);
    console.log("getkyc", response2);
    setUser(response?.data?.message);
    setFirstName(response?.data?.message?.firstName);
    setLastName(response?.data?.message?.lastName);
    setUserName(response?.data?.message?.username);
    setAddress(response?.data?.message?.address);
    setCountryCode(response?.data?.message?.countryCode);
    setPhone(response?.data?.message?.phoneNumber);
    setCompanyName(response?.data?.message?.companyName);
    setBankDetailsFilled(response?.data?.message?.bankDetailsFilled);
    setCountry(response?.data?.message?.bankDetails?.bankCountry);
    setSelectedBank(response?.data?.message?.bankDetails?.bankCode);
    setAccountNum(response?.data?.message?.bankDetails?.accountNumber);
    setAccName(response?.data?.message?.bankDetails?.bankFullName);
    setKycStatus(response?.data?.message?.kycStatus);


    setFacilityName(response2?.data?.message?.companyName);
    setFacilityDescription(response2?.data?.message?.facilityCategory === "green" ? response2?.data?.message?.greenProjectDescription : response2?.data?.message?.facilityDescription);
    setLocation(response2?.data?.message?.facilityCategory === "green" ? response2?.data?.message?.greenProjectLocation : response2?.data?.message?.facilityLocation);
    setGreenProjectLicenseId(response2?.data?.message?.greenProjectLicenseId);
    setProjectStartDate(response2?.data?.message?.facilityCategory === "green" ? response2?.data?.message?.greenProjectStartDate : response2?.data?.message?.projectStartDate);
    setProjectEndDate(response2?.data?.message?.facilityCategory === "green" ? response2?.data?.message?.greenProjectEndDate : response2?.data?.message?.facilityEndDate);
    setFuelSource(response2?.data?.message?.projectFuelSource);
    setRenewableEnergySolutions(response2?.data?.message?.renewableEnergySolutions);
    setBaseline(response2?.data?.message?.baseLineScenario);
    setFuelSourceBaseline(response2?.data?.message?.facilityCategory === "green" ? response2?.data?.message?.baseLineEnergySource : response2?.data?.message?.baseLineFuelSource);
    setAdditonalInfo(response2?.data?.message?.additionalInfomation);
    setSustainabilitySolution(response2?.data?.message?.sustainabilitySolution);
    setFacilityCategory(response2?.data?.message?.facilityCategory);
    setPublicKey(response2?.data?.message?.walletAddress);
  };

  const handleGetBank = async () => {
    if (!!country) {
      setBankLoading(true);
      const response = await getBanks(country, auth?.userInfo?.id);
      console.log("countries", response);

      if (response?.data?.status === true) {
        setBanks(response?.data?.data);
      } else {
        alert("Unable to fetch banks");
      }
      setBankLoading(false);
    }
  };

  useEffect(() => {
    handleGetBank();
  }, [country]);

  useEffect(() => {
    fetchUserInfo();
  }, []);
  useEffect(() => {
    console.log('accountNum', accountNum);
    
  }, [accountNum]);

  const handleUserUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("username", username);

    if(justAddedBankDetails) {
      await handleSaveBankDetails();
    }
    const response = await updateUserInfo(
      firstName,
      lastName,
      username,
      address,
      phone,
      countryCode,
      auth?.token
    );

    console.log("update user", response);
    if (response?.data?.statusCode === 200) {
      toast.success(response?.data?.message);
    } else {
      alert(response?.data?.message);
    }
    setLoading(false);
  };

  const handleKycUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await updateUserKycUser(
      "user update",
      location,
      quantifiedBasedYearInventory,
      pdrDoc,
      auth?.userInfo?.id,
      auth?.token
    );
    

    console.log('updateUserKycUser', response);

    if (response?.data?.statusCode === 200) {
      // update(ref(db, `kycStatus/${kycKeys[0]}`), {
      //   status: "completed",
      // });
      toast.success("Kyc updated successfully");
    } else {
      toast.error("Something went wrong");
    }
    setLoading(false);
  };

  const handleVerifyAccount = async () => {
    setVerifyLoading(true);
    const response = await verifyAccount(accountNum, selectedBank, auth?.token);
    console.log("respo", response);

    if (response?.data?.status === true) {
      setAccName(response?.data?.data?.account_name);
      setJustAddedBankDetails(true)
    } else {
      alert("Unable verify account number");
    }

    setVerifyLoading(false);
  };

  const handleSaveBankDetails = async () => {
    setLoading(true);
    console.log({
      accountNum,
      id: auth?.userInfo?.id,
      country,
      selectedBank,
      token: auth?.token
    });
    
    const response = await saveBankDetails(
      accountNum,
      auth?.userInfo?.id,
      country,
      selectedBank,
      auth?.token
    );
    console.log("respo", response);

    if (response?.data?.statusCode === 200) {
      setAccName(response?.data?.data?.account_name);
    } else {
      alert("Unable to save bank details");
    }

    setLoading(false);
  };
  // for grand truth mapping 
 const [formData, setFormData] = useState("");

  const handleChange = (category, index, newValue) => {
    const updatedCategory = [...formData[category]];
    updatedCategory[index].value = newValue;

    setFormData({
      ...formData,
      [category]: updatedCategory,
    });
  };

    // Use react-query for withdrawal history
    const { data, isLoading, error } = useQuery({
      queryKey: ["getTruthMapping", auth?.token],
      queryFn: () =>getGrandTruthMapping (auth?.token),
      enabled: !!auth?.token,
    });
  
    // Extract withdrawal items from API response
    const getTruthMapping = data?.data?.data?.items || [];
  console.log("withdrawalItems", getTruthMapping);
  
if(error){
  console.log(error)
}if(data){
  console.log(data?.data?.data)
}

  return (
    <div className="profile">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="main">
        <Search />

        <div className="name">
          <div className="abv">
            {firstName?.split("")[0]}
            {lastName?.split("")[0]}
          </div>
          <div className="name_inner">
            <div className="">
              {firstName?.split("")[0]}
              {lastName?.split("")[0]}
            </div>
            <div>{auth?.userInfo?.email}</div>
          </div>
        </div>

        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label="basic tabs example"
          className="tab_label_container"
        >
          <Tab
            className={value === 0 ? "tab_label" : "tab_label tab_active"}
            label="Personal Details"
            {...a11yProps(0)}
          />
          <Tab
            className="tab_label"
            label="Company Details"
            {...a11yProps(1)}
          />
          <Tab className="tab_label" label="KYC" {...a11yProps(2)} />
          { auth?.userInfo?.subscriptionPlan === "business" || auth?.userInfo?.subscriptionPlan === "" &&
          <Tab className="tab_label " label="Ground truth mapping" {...a11yProps(3)} />}
          {/* <Tab className="tab_label" label="AI Update" {...a11yProps(3)} /> */}
        </Tabs>
        {/* <TabPanel value={value} index={0}> */}
        {value === 0 && (
          <form onSubmit={handleUserUpdate} className="profile_form">
            <div className="input_container">
              <div>First Name*</div>
              <input
                type="text"
                placeholder="First name"
                value={firstName}
                name="firstName"
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </div>
            <div className="input_container">
              <div>Last Name*</div>
              <input
                type="text"
                placeholder="Last name"
                value={lastName}
                name="lastName"
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </div>
            <div className="input_container">
              <div>User Name*</div>
              <input
                type="text"
                placeholder="Username"
                value={username}
                name="username"
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>
            <div className="input_container">
              <div>Address*</div>
              <input
                type="text"
                placeholder="Postal Address"
                value={address}
                name="address"
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </div>
            <div className="input_container">
              <div>Phone Number*</div>
              <div className="input_group">
                <input
                  type="text"
                  className="cc-input"
                  placeholder="Country Code"
                  value={countryCode}
                  name="countryCode"
                  onChange={(e) => setCountryCode(e.target.value)}
                  required
                />
                <input
                  type="text"
                  placeholder="Phone Number"
                  value={phone}
                  name="phone"
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="input_container">
              <div>Country</div>
              <select
                name=""
                id=""
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                required
                disabled={bankDetailsFilled}
              >
                <option value="">Country</option>
                <option value="NGN">Nigeria</option>
                <option value="GHS">Ghana</option>
                <option value="KES">Kenya</option>
                <option value="XOF">Côte d'Ivoire</option>
                <option value="EGP">Egypt</option>
                <option value="ZAR">South Africa</option>
              </select>
            </div>
            <div className="input_container">
              <div>Select bank</div>
              <select
                name=""
                id=""
                value={selectedBank}
                onChange={(e) => setSelectedBank(e.target.value)}
                required
                disabled={bankDetailsFilled}
              >
                <option value="">{bankLoading ? "Loading..." : !country ? "Select country first" : "Bank"}</option>
                {/* {banks?.length < 1 && 
                  <option value="">Please select country first</option>
                  } */}
                {banks?.map((bank) => (
                  <option value={bank?.code}>{bank?.name}</option>
                ))}
              </select>
            </div>
            <div className="input_container">
              <div>Account number</div>
              <div className="input_container__verify">
                <input
                  type="text"
                  placeholder="Enter account number"
                  value={accountNum}
                  name="address"
                  onChange={(e) => setAccountNum(e.target.value)}
                  required
                  disabled={bankDetailsFilled}
                />
                <button onClick={handleVerifyAccount} disabled={verifyLoading || bankDetailsFilled}>
                  {verifyLoading ? "Loading..." : "Verify"}
                </button>
              </div>
            </div>

            <div className="input_container">
              <div>Account name</div>
              <input
                type="text"
                placeholder="Enter account name"
                value={accName}
                name="address"
                // onChange={(e) => setAddress(e.target.value)}
                // required
                disabled
              />
            </div>

            <button
              type="submit"
              className="settings_submit"
              disabled={loading}
            >
              {loading ? "Loading..." : "Save Changes"}
            </button>
          </form>
        )}
        {value === 1 && (
          <form onSubmit={handleUserUpdate} className="profile_form">
            <div className="input_container">
              <div>Company Name</div>
              <input
                type="text"
                placeholder="Company name"
                value={companyName}
                name="companyName"
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>
            {/* <div className="input_container">
            <div>Organisation Desc.</div>
            <textarea type="text" placeholder="Organisation Description"></textarea>
          </div> */}

            {/* <div className="input_container">
            <div>Phone Number</div>
            <div className="input_group">
              <input type="text" placeholder="Country Code" />
              <input
                type="text"
                placeholder="Phone Number"
              />
            </div>
          </div> */}
            {/* <div className="input_container">
            <div>Postal Address</div>
            <input type="text" placeholder="Postal Address" />
          </div> */}

            <button type="submit" className="settings_submit">
              Save Changes
            </button>
          </form>
        )}
        {value === 2  && (
          <form id="kyc" className="profile_form" onSubmit={handleKycUpdate}>
             {comment?.data?.length > 0 ? (
      comment.data.map((item, index) => (
        <div key={index} className="border border-[#DD900D]/40 bg-[#FEF6E7] rounded-lg p-4 mb-3">
          <p className="font-semibold text-[#DD900D] text-[18px] leading-[27px]">
            {item.selectedReason}
          </p>
          <p className="text-[#DD900D] text-[16px] leading-[24px] mt-2">
            {item.additionalComment}
          </p>
        </div>
      ))
    ) : (
      <div className="text-[#DD900D] text-[16px] font-medium">
    
      </div>
    )}
            <div className="input_container">
            
              <div>
              Project/Facility name
              </div>
              <input
                type="text"
                value={facilityName}
                name="location"
                onChange={(e) => setFacilityName(e.target.value)}
                disabled={!pathname.includes("editable")}
              />
            </div>
            <div className="input_container">
              <div>
              {facilityCategory === "non-green" ? "Facility/Project description" : facilityCategory === "carbon-monitoring" ? "Facility description" : "Green project description"}

              </div>
              <input
                type="text"
                value={facilityDescription}
                name="location"
                onChange={(e) => setFacilityDescription(e.target.value)}
                disabled={!pathname.includes("editable")}
              />
            </div>
            
            <div className="input_container">
              <div>
              {facilityCategory === "non-green" ? "Facility/Project location" : facilityCategory === "carbon-monitoring" ? "Facility location" : "Green project location"}

              </div>
              <input
                type="text"
                value={location}
                name="location"
                onChange={(e) => setLocation(e.target.value)}
                disabled={!pathname.includes("editable")}
              />
            </div>

            {facilityCategory === "green" && <div className="input_container">
              <div>
              Green project license/ID
              </div>
              <input
                type="text"
                value={greenProjectLicenseId}
                name="location"
                onChange={(e) => setGreenProjectLicenseId(e.target.value)}
                disabled={!pathname.includes("editable")}
              />
            </div>}

            <div className="input_container">
              <div>
              {facilityCategory === "non-green" ? "Facility/Project start date" : facilityCategory === "carbon-monitoring" ? "Facility start date" : "Green project start date"}
              </div>
              <input
                type="date"
                placeholder="wallet Address"
                onChange={(e) => setProjectStartDate(e.target.value)}
                value={projectStartDate}
                name="publicKey"
                disabled
              />
            </div>
            <div className="input_container">
              <div>
              {facilityCategory === "non-green" ? "Facility/Project end date" : facilityCategory === "carbon-monitoring" ? "Facility end date" : "Green project end date"}
              </div>
              <input
                type="date"
                placeholder="wallet Address"
                onChange={(e) => setProjectEndDate(e.target.value)}
                value={projectEndDate}
                name="publicKey"
                disabled
              />
            </div>
            {facilityCategory === "non-green" && <div className="input_container">
              <div>
              Facility/Project fuel source
                            </div>
              <input
                type="text"
                placeholder="wallet Address"
                onChange={(e) => setFuelSource(e.target.value)}
                value={fuelSource}
                name="publicKey"
                disabled
              />
            </div>}
            {facilityCategory === "green" && <div className="input_container">
              <div>
              Green project/ Renewable energy

                            </div>
              <input
                type="text"
                placeholder="wallet Address"
                onChange={(e) => setRenewableEnergySolutions(e.target.value)}
                value={renewableEnergySolutions}
                name="publicKey"
                disabled
              />
            </div>}
            {facilityCategory !== "carbon-monitoring" && <div className="input_container">
              <div>
              Baseline scenario

                            </div>
              <input
                type="text"
                placeholder="wallet Address"
                value={baseline}
                onChange={(e) =>
                  setBaseline(
                    e?.target?.value
                  )
                }
                name="publicKey"
                disabled
              />
            </div>}
            {facilityCategory !== "carbon-monitoring" && <div className="input_container">
              <div>
              {facilityCategory === "non-green" ? "Fuel source in baseline scenario" : "Energy source in baseline scenario"}


                            </div>
              <input
                type="text"
                placeholder="wallet Address"
                value={fuelSourceBaseline}
                onChange={(e) =>
                  setFuelSourceBaseline(e?.target?.value)
                }
                name="publicKey"
                disabled
              />
            </div>}
            {facilityCategory !== "carbon-monitoring" && <div className="input_container">
              <div>
              Additional information relevant to the project

                            </div>
              <input
                type="text"
                placeholder="wallet Address"
                value={additonalInfo}
                  onChange={(e) =>
                    setAdditonalInfo(e?.target?.value)
                  }
                name="publicKey"
                disabled
              />
            </div>}
            {facilityCategory === "non-green" && <div className="input_container">
              <div>
              Sustainability solution

                            </div>
              <input
                type="text"
                placeholder="wallet Address"
                value={sustainabilitySolution}
                onChange={(e) => setSustainabilitySolution(e.target.value)}
                name="publicKey"
                disabled
              />
            </div>}
            <div className="input_container">
              <div>Wallet Address</div>
              <input
                type="text"
                placeholder="wallet Address"
                value={publicKey}
                name="publicKey"
                disabled
              />
            </div>

{kycStatus === "rejected" &&
            <button type="submit" className="settings_submit" disabled={loading}>
              {loading ? "Loading..." : "Save Changes"}
            </button>
}
          </form>
        )}



{/* grand truth mapping  */}

{value === 3 && (auth?.userInfo?.subscriptionPlan === "business" || auth?.userInfo?.subscriptionPlan === "basic") && (
  <div className="ml-48 w-[931px] mr-64 space-y-20 p-6 bg-white">
    <div className="text-[20px] font-semibold mt-6">Home Appliance</div>

    {data?.data?.data?.homeAppliances.map((item, idx) => (
      <div key={idx}>
        <div className="flex gap-72 space-y-0 -mt-6 ">
          <div className="text-[16px] text-gray-500 mt-5 w-28">{item.name}</div>
          <div className="flex-1 px-10 py-8 mr-24 border border-gray-300 rounded-xl bg-gray-100 w-[664px] ">
            {item.voltage} W
          </div>
        </div>
      </div>
    ))}

    <div className="text-[20px] font-semibold mt-6">Facility Appliances</div>

    {data?.data?.data?.facilityAppliances.map((item, idx) => (
      <div key={idx}>
        <div className="flex gap-72 space-y-0 -mt-6 ">
          <div className="text-[16px] text-gray-500 mt-5 w-28">{item.name}</div>
          <div className="flex-1 px-10 py-8 mr-24 border border-gray-300 rounded-xl bg-gray-100 w-[664px] ">
            {item.voltage} W
          </div>
        </div>
      </div>
    ))}

    <div className="text-[20px] font-semibold mt-6">Others</div>

    {data?.data?.data?.others.map((item, idx) => (
      <div key={idx}>
        <div className="flex gap-72 space-y-0 -mt-6 ">
          <div className="text-[16px] text-gray-500 mt-5 w-28">{item.name}</div>
          <div className="flex-1 px-10 py-8 mr-24 border border-gray-300 rounded-xl bg-gray-100 w-[664px] ">
            {item.voltage} W
          </div>
        </div>
      </div>
    ))}

    <div className="flex justify-end mt-6">
      <Link to={"/settings-grand-truth-mapping"}>
        <button
          className="px-12 py-2 border border-green-500 text-green-600 font-medium rounded-xl text-[16px] hover:bg-green-50 flex items-center gap-2"
          onClick={() => console.log("Updated Data:", formData)}
        >
          Edit
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15.232 5.232l3.536 3.536M9 13l6.586-6.586a2 2 0 112.828 2.828L11.828 15.828a2 2 0 01-1.414.586H7v-3.414a2 2 0 01.586-1.414z"
            />
          </svg>
        </button>
      </Link>
    </div>
  </div>
)}


        {/* </TabPanel> */}
      </div>

    </div>
  );
};

export default Settings;
